<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7268 7.9071C17.1232 8.29157 17.133 8.92466 16.7485 9.32115L10.7146 15.5436L8.01839 12.4952C7.65251 12.0815 7.69126 11.4495 8.10496 11.0836C8.51865 10.7177 9.15063 10.7565 9.51652 11.1702L10.7821 12.6011L15.3127 7.92885C15.6972 7.53237 16.3303 7.52263 16.7268 7.9071Z"
      fill="#005988"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0402 21.8809C12.2582 21.7976 12.5336 21.6828 12.8513 21.5298C13.7345 21.1046 14.9288 20.3929 16.1265 19.2614C18.3393 17.1709 20.7147 13.5088 20.9762 7.13736L12.0521 2.27492L3.02574 7.14231C3.29637 13.2576 5.65497 16.9244 7.89086 19.0882C9.10077 20.2591 10.3086 21.0209 11.2036 21.4861C11.5322 21.6568 11.8164 21.7865 12.0402 21.8809ZM1 5.96242L12.057 0L23 5.96242C23 21.2532 12 24 12 24C12 24 1 20.7468 1 5.96242Z"
      fill="#005988"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'TrustSafetyShieldIcon',
});
</script>
